import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Download, Users } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-20 px-6 overflow-hidden bg-navy-900" data-id="element-75">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-teal-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-76" />

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-78">
          <div className="inline-block border border-teal-500/30 bg-teal-500/10 text-teal-300 px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-79">
            For the 800 million who can't sleep through back pain
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-[1.1] text-cream" data-id="element-80">
            Why Your Back Pain Is Always Worst At{' '}
            <span className="text-teal-400 italic" data-id="element-81">11PM</span> — And The{' '}
            <span className="text-teal-400 italic" data-id="element-82">12-Minute</span> Floor
            Protocol That Stops It Tonight
          </h1>

          <p className="text-lg md:text-xl text-cream-300/80 leading-relaxed max-w-xl" data-id="element-83">
            Discover the Somatic Fusion Method™ — a proven bedtime sequence
            that interrupts the nervous system pain loop so you can finally
            sleep through the night.
          </p>

          <div className="space-y-4 pt-4" data-id="element-84">
            <a href="#final-cta" className="block w-full sm:w-auto text-center bg-teal-500 hover:bg-teal-400 text-navy-900 font-bold text-xl py-4 px-8 rounded-lg shadow-[0_0_30px_rgba(20,184,166,0.3)] hover:shadow-[0_0_40px_rgba(20,184,166,0.5)] transition-all transform hover:-translate-y-1" data-id="element-85">
              Get Instant Access — $6.39
            </a>

            <div className="flex flex-wrap items-center gap-4 text-sm text-cream-300/60 font-medium" data-id="element-86">
              <div className="flex items-center gap-1.5" data-id="element-87">
                <ShieldCheck className="w-4 h-4 text-teal-500" data-id="element-88" />
                <span data-id="element-89">60-day money-back guarantee</span>
              </div>
              <span className="hidden sm:inline" data-id="element-90">•</span>
              <div className="flex items-center gap-1.5" data-id="element-91">
                <Download className="w-4 h-4 text-teal-500" data-id="element-92" />
                <span data-id="element-93">Instant download</span>
              </div>
              <span className="hidden sm:inline" data-id="element-94">•</span>
              <div className="flex items-center gap-1.5" data-id="element-95">
                <Users className="w-4 h-4 text-teal-500" data-id="element-96" />
                <span data-id="element-97">47,000+ users</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative mx-auto w-full max-w-md lg:max-w-full" data-id="element-98">
          <div className="absolute inset-0 bg-teal-500/20 blur-[60px] rounded-full" data-id="element-99" />
          <img src="https://cdn.magicpatterns.com/uploads/mdPNgk2XAGWNJRTnFmS9qf/The_11pm_Spine_Reset_eBook_Cover.png" alt="The 11PM Spine Reset eBook Cover" className="relative z-10 w-full h-auto rounded-lg shadow-2xl border border-white/10" data-id="element-100" />
        </motion.div>
      </div>
    </section>;
}